import React from 'react';

import { PageLayout } from 'src/core/components';
import { EditSequence } from 'src/components';

export const EditSequencePage = () => (
  <PageLayout withBreadCrumbs={false}>
    <EditSequence />
  </PageLayout>
);

EditSequencePage.propTypes = {};

export default EditSequencePage;
